import axios from "axios";
import { config_multipart } from "../../../../helper-functions/api-header-config";
import secureLocalStorage from "react-secure-storage";
const REACT_APP_CENTRAL_API_URL = process.env.REACT_APP_API_URL_CENTRAL;

// Add User
export const add_user = async (formData:object) => {
    const response = await axios.post(secureLocalStorage.getItem("baseURL") + "/api/user", formData, {
    });
    return response.data;
};
export const add_tenant_user = async (formData:object) => {
  const response = await axios.post(REACT_APP_CENTRAL_API_URL + "/api/add-tenant-user", formData, {
  });
  return response.data;
};
export const get_tenant_setting = async () => {
  const response = await axios.get(secureLocalStorage.getItem("baseURL") + '/api/get-tenant-setting');
    return response.data.data;
};
export const verify_user = async (email) => {
  let response = await axios.post(REACT_APP_CENTRAL_API_URL + "/api/user-exists", {
    'email': email
  });
  return response.data;
}
// Assign Role
export const add_assign_role = async (formData:object) => {
  const response = await axios.post(secureLocalStorage.getItem("baseURL") + "/api/assign-role-to-employee", formData, {
  });
  return response.data;
};
// Get All Roles
export const get_all_roles = async () => {
  let response = await axios.get(secureLocalStorage.getItem("baseURL") + "/api/active-roles");
  return response.data;
}
// List Of Users
export const get_all_users = async () => {
  let response = await axios.get(secureLocalStorage.getItem("baseURL") + "/api/user");
  return response.data;
}
// List Of Users
export const get_all_active_users= async () => {
  let response = await axios.get(secureLocalStorage.getItem("baseURL")+"/api/get-all-active-users");
  return response.data;
}
// List Of Users
export const get_all_active_users_without_role= async () => {
  let response = await axios.get(secureLocalStorage.getItem("baseURL")+"/api/get-all-active-users-without-role");
  return response.data;
}

// Get Single User
export const get_single_user = async (id) => {
  let response = await axios.get(secureLocalStorage.getItem("baseURL") + "/api/user/"+id);
  return response.data;
}
// Get Single User
export const get_user_profile = async () => {
  let response = await axios.get(secureLocalStorage.getItem("baseURL") + "/api/get-user-profile");
  return response.data;
}
// Get Single User Logs by ID
export const get_user_logs = async (id: number) => {
  let response = await axios.get(secureLocalStorage.getItem("baseURL") + "/api/user-activity-log/" + id);
  return response.data;
};
// Get All Users Logs
export const get_all_users_logs = async () => {
  let response = await axios.get(secureLocalStorage.getItem("baseURL") + "/api/employee-personal-details-activity-logs");
  return response.data;
};
// Delete User
export const delete_user = async (id: number) => {
  let response = await axios.delete(secureLocalStorage.getItem("baseURL") + "/api/user/" + id);
  return response.data;
}
export const update_tenant_user = async (formData:object) => {
  const response = await axios.post(REACT_APP_CENTRAL_API_URL + "/api/update-tenant-user", formData,config_multipart)
return response.data;
}
// Edit Assign role
export const update_assign_role_user = async (id:number,data) => {
  const response = await axios.patch(secureLocalStorage.getItem("baseURL") + "/api/update-role/" + id,data)
return response.data;
}
export const update_user_profile_central = async (formData:object) => {
  const response = await axios.post(REACT_APP_CENTRAL_API_URL + "/api/update-user-profile", formData,config_multipart)
return response.data;
}
// Edit User
export const update_user = async (id:number,formData:object) => {
    const response = await axios.post(secureLocalStorage.getItem("baseURL") + "/api/update-user/" + id, formData,config_multipart)
  return response.data;
}
export const update_profile = async (formData:object) => {
  const response = await axios.post(
    `${secureLocalStorage.getItem("baseURL")}/api/update-user-profile`,
    formData, // Send formData as the request body
    config_multipart
  );
return response.data;
}
// User Reset Passowrd
export const user_password_reset = async (token, email, password, password_confirmation) => {
  const response = await axios.post(
    `${secureLocalStorage.getItem("baseURL")}/api/reset-password`,
    {
      token: token,
      email: email,
      password: password,
      password_confirmation: password_confirmation
    }
  );
  return response.data;
};
 //Filters on User List
 export const get_all_filters_item_users = async (filterPayload) => {
  const response = await axios.post(secureLocalStorage.getItem("baseURL") + '/api/user-filters',filterPayload);
  return response.data;
};
